export const BILLING_INTERVALS = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
};

export const OWNER_PLANS = [
  {
    id: "pro-enterprise",
    name: "PRO ENTERPRISE",
    type: "Inmobiliaria",
    title: "Publica propiedades sin límite",
    headerBg: "bg-black",
    headerTextColor: "text-white",
    isPopular: true,
    contactLabel: "Hablar con un ejecutivo",
    contactUrl:
      "https://api.whatsapp.com/send?phone=+523319100955&text=Hola,%20quiero%20informaci%C3%B3n%20sobre%20PRO%20ENTERPRISE.",
    features: [
      { text: "5 usuarios", included: true },
      { text: "15 destacados", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: true },
      { text: "Micrositio con buscador propio", included: true },
      { text: "Conexión a CRMs", included: true },
    ],
    idPlan: "pro-enterprise",
    billingOptions: {
      [BILLING_INTERVALS.MONTHLY]: {
        duration: "Suscripción mensual",
        priceId: import.meta.env.VITE_PUBLIC_ILIMITADO || "price_1RO2kjHL1VaYnpMDDrpgfMYN",
      },
      [BILLING_INTERVALS.ANNUAL]: {
        duration: "Suscripción anual",
        priceId: import.meta.env.VITE_PUBLIC_ILIMITADO_ANNUAL || "price_1Spz9rHL1VaYnpMDrhPnNzPE",
      },
    },
  },
  {
    id: "pro-50",
    name: "PRO 50",
    type: "Inmobiliaria",
    title: "50 Propiedades",
    headerBg: "bg-[#5CD495]",
    headerTextColor: "text-black",
    features: [
      { text: "4 usuarios", included: true },
      { text: "8 destacados", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: true },
      { text: "Micrositio con buscador propio", included: true },
      { text: "Conexión a CRMs", included: true },
    ],
    idPlan: "pro-50",
    billingOptions: {
      [BILLING_INTERVALS.MONTHLY]: {
        price: "$1,580/mes",
        duration: "Suscripción mensual",
        priceId: import.meta.env.VITE_PUBLIC_PRO_50 || "price_1Spz7vHL1VaYnpMD1PJpltNZ",
      },
      [BILLING_INTERVALS.ANNUAL]: {
        price: "$15,500/año",
        duration: "Suscripción anual",
        priceId: import.meta.env.VITE_PUBLIC_PRO_50_ANNUAL || "price_1Spz8LHL1VaYnpMDeD16lXIP",
      },
    },
  },
  {
    id: "pro-mini-10",
    name: "PRO MINI 10",
    type: "Inmobiliaria",
    title: "10 Propiedades",
    headerBg: "bg-[#CAA9F5]",
    headerTextColor: "text-black",
    features: [
      { text: "1 usuario", included: true },
      { text: "2 destacados", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: true },
      { text: "Micrositio con buscador propio", included: true },
      { text: "Conexión a CRMs", included: false },
    ],
    idPlan: "pro-mini-10",
    billingOptions: {
      [BILLING_INTERVALS.MONTHLY]: {
        price: "$990/mes",
        duration: "Suscripción mensual",
        priceId: import.meta.env.VITE_PUBLIC_MINI_10 || "price_1Spz2sHL1VaYnpMDekmM7ok3",
      },
      [BILLING_INTERVALS.ANNUAL]: {
        price: "$9,900/año",
        duration: "Suscripción anual",
        priceId: import.meta.env.VITE_PUBLIC_MINI_10_ANNUAL || "price_1Spz3THL1VaYnpMDD2wWIvVy",
      },
    },
  },
  {
    id: "pro-mini-5",
    name: "PRO MINI 5",
    type: "Inmobiliaria",
    title: "5 Propiedades",
    headerBg: "bg-[#CAA9F5]",
    headerTextColor: "text-black",
    features: [
      { text: "1 usuario", included: true },
      { text: "1 destacado", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: false },
      { text: "Micrositio con buscador propio", included: false },
      { text: "Conexión a CRMs", included: false },
    ],
    idPlan: "pro-mini-5",
    billingOptions: {
      [BILLING_INTERVALS.MONTHLY]: {
        price: "$550/mes",
        duration: "Suscripción mensual",
        priceId: import.meta.env.VITE_PUBLIC_MINI || "price_1Spz0OHL1VaYnpMDJN7NxAO2",
      },
      [BILLING_INTERVALS.ANNUAL]: {
        price: "$5,500/año",
        duration: "Suscripción anual",
        priceId: import.meta.env.VITE_PUBLIC_MINI_ANNUAL || "price_1Spz0sHL1VaYnpMDS5UTE5ud",
      },
    },
  },
  {
    id: "pro-gratis",
    name: "PRO Gratis",
    price: "Gratis",
    duration: "Prueba sin costo",
    type: "Gratis",
    title: "0 Propiedades",
    headerBg: "bg-gray-200",
    headerTextColor: "text-gray-800",
    features: [
      { text: "1 usuario", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Reportes", included: false },
      { text: "Micrositio con buscador propio", included: false },
      { text: "Conexión a CRMs", included: false },
    ],
    idPlan: "pro-gratis",
    priceId: null,
  },
];

export function getOwnerPlans(billingInterval) {
  const interval = Object.values(BILLING_INTERVALS).includes(billingInterval)
    ? billingInterval
    : BILLING_INTERVALS.MONTHLY;

  return OWNER_PLANS.flatMap((plan) => {
    if (!plan.billingOptions) return [plan];

    const billingOption = plan.billingOptions[interval];
    return billingOption ? [{ ...plan, ...billingOption }] : [];
  });
}
